import { Box3, Vector3 } from 'three';
import { Wall } from '../product-models/views/Wall';
import { WallMovementConstraint } from '../product-models/views/WallPositionConstraint';
import { MeasurementLine } from 'src/app/configurator/product/product-configuration/models/RayMeasurements/MeasurementLine';
import { Product } from '../product-models/views/Product';
import { LocalizedText } from '../product-models/views/LocalizedText';
import { AttributeDTO } from '../product-models/DTOs/AttributeDTO';
import { AttributeValueDTO } from '../product-models/DTOs/AttributeValueDTO';
import { ProductDTO } from '../product-models/DTOs/ProductDTO';
import { GlowControlls } from 'src/app/configurator/product/product-configuration/models/ConfiguratorRenderer';

export interface WallIntersection {
  wall: Wall;
  position: Vector3;
}

export interface IDimensions {
  width: number;
  height: number;
  length: number;
}

export enum WallTypeEnum {
  Floor = 'Floor',
  Wall = 'Wall',
  Ceiling = 'Ceiling',
}

export enum WallSideEnum {
  Top = 'Top',
  Bottom = 'Bottom',
  Left = 'Left',
  Right = 'Right',
}

export enum UtilityType {
  Water = 'Water',
  Electric = 'Electric',
}

export enum CoveringType {
  Texture = 'Texture',
  Color = 'Color',
}

export interface ClipBBoxWithDistance {
  clipBBox: Box3;
  distance: number;
  wallData: WallMovementConstraint;
}

export interface PositionAndWallMovementConstraint {
  position: Vector3;
  wallMovementConstraint: WallMovementConstraint;
}

export enum CollisionDescriptorType {
  OBB = 'OBB',
}

export enum CollisionDescriptorUsageType {
  DEFAULT = 'DEFAULT',
  CLEARENCE = 'CLEARENCE',
  WALL_CLEARENCE = 'WALL_CLEARENCE',
  SELF = 'SELF',
}

export enum NumericAttributeTypeEnum {
  SELECT = 'SELECT',
  INPUT = 'INPUT',
}

export interface MeasurementLinesAndMeasuredProducts {
  measurementLines: MeasurementLine[];
  products: Product[];
}

export enum Breakpoint {
  XS = 400,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
}

export enum MeasurementModeEnum {
  OuterMeasurements = 'OuterMeasurements',
  RayMeasurements = 'RayMeasurements',
  None = 'None',
}

export interface Hideable {
  show: LocalizedText[];
  hide: LocalizedText[];
}

export interface ProductRelationshipGroupFullfilment {
  productBlueprintExternalIds: string[];
  notFullfiledText: LocalizedText[];
}

export interface ISeriesSettings {
  uiSettings: {
    showARButton?: boolean;
    showZoomButton?: boolean;
    showCameraViewChangeButtons?: boolean;
    showLockCamera?: boolean;
    showPoweredBy?: boolean;
    showDetails?: boolean;
    showStepper?: boolean;
    globalSettingsAlwaysVisible?: boolean;
    hideBlueprintSelectionOnSelect?: boolean;
    hideable: Hideable | undefined;
    showProductBlueprintDimensions: boolean;
  };

  renderSettings: {
    glowControlls: Partial<GlowControlls>;
  };

  cameraSettings: {
    recenterCameraOnBoundsChange?: boolean;
    initialCameraPosition: number[];
    initialTargetPosition: number[];
    maxPolarAngle: number;
  };
  placeInitialProduct?: boolean;
  fullyImport?: boolean;
  showShoppingCart?: boolean;
  preloadModels?: boolean;
  measurementMode?: MeasurementModeEnum;
  layoutConfiguration: boolean;
  productRelationshipGroupFullfilment: ProductRelationshipGroupFullfilment;
  skipCalculatingNormals: boolean;
  customStyling: any;
}

export interface IAttributeValueAvailibility {
  reason?: attributeAvailibilityReasonEnum;
  isAvailible: boolean;
}

export enum attributeAvailibilityReasonEnum {
  elementsInside = 'elements-inside',
  internalError = 'internal-error',
}

export interface ProductDTOWithAttributeValuePair {
  attributeDTO: AttributeDTO;
  attributeValueDTO: AttributeValueDTO;
  productDTO: ProductDTO;
}
